"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CanvasNoOpGraphicsComponent = void 0;
const no_transform_provider_1 = require("../../rendering/transform-components/no-transform-provider");
const e_graphics_component_type_1 = require("../../rendering/graphics-components/e-graphics-component-type");
/**
 * @public
 * A graphics component for canvas renderer that doesn't draw.
 */
class CanvasNoOpGraphicsComponent {
    constructor() {
        this.type = e_graphics_component_type_1.EGraphicsComponentType.Entity;
        this.specification = {};
        this.transform = new no_transform_provider_1.NoTransformProvider();
    }
    getCacheId() {
        return "NoOpGraphicsComponent";
    }
    initialize() {
        // no action needed
    }
    onBeforeUpdate() {
        // no action needed
    }
    update() {
        // no action needed
    }
}
exports.CanvasNoOpGraphicsComponent = CanvasNoOpGraphicsComponent;
//# sourceMappingURL=canvas-no-op-graphics-component.js.map